import { useState, type ReactNode } from 'react'

import { env } from '@/src/config/env'
import { Modal } from '@/src/elements/modal/Modal'
import { TEST_ID } from '@/src/general/constants/testId'
import { useCaptchaV2 } from '@/src/general/hooks/useCaptcha'
import { useTranslate } from '@/src/lang/useTranslate'

type TCaptchaV2ModalProps = {
  isOpen: boolean
  onCaptchaComplete: (token: string) => void
  onClose: VoidFunction
}

export const CaptchaV2Modal = ({ isOpen, onCaptchaComplete, onClose }: TCaptchaV2ModalProps): ReactNode => {
  const [captchaToken, setCaptchaToken] = useState<string | null>(null)
  const { t } = useTranslate()
  const { CaptchaV2Component } = useCaptchaV2()

  const handleCaptchaChange = (token: string | null) => {
    setCaptchaToken(token)
  }

  const handleConfirm = () => {
    if (captchaToken) {
      onCaptchaComplete(captchaToken)
    }
  }

  const siteKey = env.EXPO_PUBLIC_CONF_KEY_GOOGLE_RECAPTCHA_V2 || ''

  return (
    <Modal
      testID={TEST_ID.CONTACT.CAPTCHA_V2_MODAL}
      showModal={isOpen}
      title={t('contact.captcha_v2.title')}
      showCancelButton
      confirmButtonProps={{ isDisabled: !captchaToken }}
      onCancel={onClose}
      onConfirm={handleConfirm}
      cancelText={t('word.cancel')}
      confirmText={t('word.validate')}
    >
      {CaptchaV2Component && <CaptchaV2Component sitekey={siteKey} onChange={handleCaptchaChange} />}
    </Modal>
  )
}
